// CommentReplyModal.jsx

import React, { useState } from 'react';

// Device Detection
import { useIsMobile } from 'hooks/useDeviceDetect';

// CSS
import './CommentReplyModal.css';

// Components
import Button from 'components/button/Button';
import Divider from 'components/divider/Divider';
import ModalButtons from 'components/modal/buttons/ModalButtons';
import ModalForm from 'components/modal/form/ModalForm';
import Modal from 'components/modal/Modal';
import TextInput from 'components/textinput/TextInput';

/**
 * CommentReplyModal
 * 
 * @returns {ReactNode} - CommentReplyModal component.
 */
const CommentReplyModal = ({ comment, isOpen, setOpen, onReplySaved }) => {

    // ----- DEVICE DETECTION ----- //

    const isMobile = useIsMobile();

    // ----- STATE ----- //

    // State

    const [reply, setReply] = useState("");

    // ----- HANDLERS ----- //

    /**
 * Handles save.
 */

    const handleSave = () => {
        onReplySaved(reply);
        setReply("");
        setOpen(false);
    };

    if (!comment) return null;

    // ----- RENDER ----- //

    return (
        <Modal
          reply={`Replying to ${comment.user.name}`}
          isOpen={isOpen}
          width={isMobile ? '100%' : 460}
          height="auto"
          maxHeight="80vh"
          title={`Replying to ${comment.user.name}`}
          onClose={() => setOpen(false)}
        >
            <ModalForm>
            <div className="comment-reply-modal-container">

                {/* TOP */}
                <div className="comment-reply-modal-top">

                    {/* COMMENT REPLY PARENT */}
                    <div
                      className="comment-reply-parent"
                    >
                        "{comment.text}"
                    </div>

                </div>

                <Divider />

                {/* BOTTOM */}
                <div className="comment-reply-modal-bottom">

                    <TextInput
                      style={{
                            maxHeight: '200px',
                        }}
                      value={reply}
                      maxLength={500}
                      autoFocus
                      showCount
                      expandable
                      multiline
                      onChange={(e) => setReply(e.target.value)}
                    />

                </div>

            </div>
            </ModalForm>

            <ModalButtons>
                        <Button
                          iconKey="send"
                          label="Send"
                          onClick={handleSave}
                        />
                    </ModalButtons>

        </Modal>
    );
};

// Dev Tools
CommentReplyModal.displayName = 'CommentReplyModal';

export default CommentReplyModal;
